export enum InactiveId {
  inactive = 'inactive',
  all = 'all'
}
